import { addCells } from "../addCells";
import { clearSelectedBorders } from "../clearSelectedBorders";
import { pushCellHistory } from "../pushCellHistory";
import { selectedSegments } from "../selectedIntervals";
import { Cell, State } from "../types";

export type DeleteSelectedSegmentsAction = Readonly<{
  type: "DELETE SELECTED SEGMENTS";
}>;

const cellAlongInterval = (interval: [number, number]) => (cell: Cell): boolean => {
  switch (cell.selectedBorder) {
    case "bottom":
    case "top":
      return cell.minX >= interval[0] && cell.maxX <= interval[1];
    case "left":
    case "right":
      return cell.minY >= interval[0] && cell.maxY <= interval[1];
    default:
      return false;
  }
};

export const deleteSelectedSegments = (
  state: State,
  _action: DeleteSelectedSegmentsAction,
): State => {
  const intervals = selectedSegments(state.cells);
  if (intervals.length < 1) {
    return state;
  }
  const newCells: Array<Cell> = [];
  for (const interval of intervals) {
    const adjacentCells = state.cells.filter(cellAlongInterval(interval));
    newCells.push({
      maxX: Math.max(...adjacentCells.map(c => c.maxX)),
      maxY: Math.max(...adjacentCells.map(c => c.maxY)),
      minX: Math.min(...adjacentCells.map(c => c.minX)),
      minY: Math.min(...adjacentCells.map(c => c.minY)),
      selectedBorder: null,
      selected: false,
    });
  }
  if (newCells.length < 1) {
    return state;
  }
  const cells: State["cells"] = clearSelectedBorders(addCells(state.cells, newCells));
  return pushCellHistory(state, cells);
};
